// PLAN.md §6.7 — local identity stored in browser localStorage.

const STORAGE_KEY = 'tg.identity.v1'

export type Identity = {
  handle: string
  display_handle: string
  auth_token: string
}

export function loadIdentity(): Identity | null {
  try {
    const raw = window.localStorage.getItem(STORAGE_KEY)
    if (!raw) return null
    const parsed = JSON.parse(raw) as Partial<Identity>
    if (
      typeof parsed.handle === 'string' &&
      typeof parsed.display_handle === 'string' &&
      typeof parsed.auth_token === 'string'
    ) {
      return parsed as Identity
    }
    return null
  } catch {
    return null
  }
}

export function saveIdentity(id: Identity): void {
  window.localStorage.setItem(STORAGE_KEY, JSON.stringify(id))
}

export function clearIdentity(): void {
  window.localStorage.removeItem(STORAGE_KEY)
}
